import { createCarousel } from "../carousel/utils/createCarousel";
import { createCta } from "./html-elements/cta";
import { callApi } from "./utils/callApi";
import { getOptions } from "./utils/getOptions";

export const groupItems = (items, maxPageSize = 4) => {
  const groupedItems = [];
  let group = [];
  items.forEach((item, index) => {
    group.push(item);
    if (group.length === maxPageSize) {
      groupedItems.push(group);
      group = [];
    }
    if (index === items.length - 1 && group.length > 0) {
      groupedItems.push(group);
    }
  });
  return groupedItems;
};

export const handleApiData = (data, layout) => {
  const items = data.map((item, index) => {
    const product = item.products[0];
    return {
      productUrl: product.pdpUrl,
      ariaLabel: product.name,
      imageUrl: item.assets[1].url,
      itemIndex: index,
    };
  });

  const itemsPerPage = layout === "mobile" ? 4 : 1;
  const groupedItems = groupItems(items, itemsPerPage);
  
  return groupedItems;
};

export const createCategoryListItem = (products, ctaRef) => (itemsArray, index) => {
  const nextPage = products[index + 1];
  return `
    <li class="carousel__item">
    ${itemsArray
      .map(
        (item) => `
        <a href="${item.productUrl}#ctaref-${ctaRef || ""}+ugc+asom+carousel_${item.itemIndex}&featureref1-ugc+asom+carousel" aria-label="${item.ariaLabel}">
          <img src="${item.imageUrl}" alt="${item.ariaLabel}" />
        </a>`
      )
      .join("")}
      ${!nextPage ? `<div class="last-page-spacer"></div>` : ""}
    </li>
  `;
};

export const UGCGallery = async (element, layout) => {
  const options = getOptions(element);
  const data = await callApi(options);

  const products = handleApiData(data, layout);

  const headline = options.headline 
    ? `<h2 class="title">${options.headline}</h2>` : "";
  const description = options.description 
    ? `<p class="subtitle">${options.description}</p>` : "";
  const cta = options.ctaText ? createCta(options, products) : "";
  const header = headline || description || cta ? `<div class="carousel-header-container">
      <div class="carousel-title">
        ${headline}
        ${description}
      </div>
      ${ cta ? cta : ""}
    </div>` : "";


  const carouselConfig = {
    rootAriaLabel: "Carousel",
    type: "carousel",
    root: "carousel",
    headline: header,
    next: {
      buttonColor: options.buttonColour,
    },
    prev: {
      buttonColor: options.buttonColour,
    },
    maxPageSize: 4,
    mobilePageSize: 1,
    hideDots: false,
    listItemFunc: createCategoryListItem(products, options.ctaRef),
  };
  element.innerHTML = createCarousel(products, carouselConfig);
  element.classList.add("no-spin");
};
